import { useSuspenseQuery } from '@tanstack/react-query';

import { ApiResponseError } from '@api/apiUtils/ApiResponseError';
import { getActiveUserOptions } from '@api/users/api.users.options';

import type { CurrentUserFetchResponse } from './api.users.types';

export const useActiveUser = () => {
  return useSuspenseQuery<CurrentUserFetchResponse, ApiResponseError>(
    getActiveUserOptions,
  );
};
